import * as yup from 'yup'
import { StringSchema } from 'yup'
import { validRegexDescription, validRegexId, validRegexPostalcode } from '@geartrack/shared-lib/dist/PackageModel'

type validationInput = {
  extendTrackingId?: (schema: StringSchema) => StringSchema
  trackingIdRequiredHelp?: string
  t: any
}

export const packageValidationSchema = (input: validationInput) => {
  let trackingId = yup
    .string()
    .required(input.trackingIdRequiredHelp ?? input.t('trackingId.required', { ns: 'validation' }))
    .min(4, input.t('trackingId.min', { count: 4, ns: 'validation' }))
    .max(40, input.t('trackingId.max', { count: 40, ns: 'validation' }))
    .matches(validRegexId, input.t('trackingId.regex', { ns: 'validation' }))

  if (input.extendTrackingId) {
    trackingId = input.extendTrackingId(trackingId)
  }

  return yup.object().shape({
    trackingId: trackingId,
    description: yup
      .string()
      .max(50, input.t('description.max', { count: 50, ns: 'validation' }))
      .matches(validRegexDescription, input.t('description.regex', { ns: 'validation' })),

    // optional fields validation
    postalcode: yup
      .string()
      .matches(validRegexPostalcode, input.t('postalcode.regex', { ns: 'validation' }))
      .min(2, input.t('postalcode.min', { ns: 'validation' }))
      .max(40, input.t('postalcode.max', { ns: 'validation' })),

    countryCode: yup.string().matches(/^[A-Z]{2}$/, input.t('countryCode.regex', { ns: 'validation' })),
  })
}
